angular.
module("dx.webapp.register").
directive("dxRegister", function registerDirective() {
	"use strict";

	return {
		restrict: "E",
		templateUrl: "tmpl/register/register-directive.html",
		controller: "DxRegisterDirectiveController",
		bindings: {
			invite: "=",
		},
	};
});
